import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { ExportTagDetails } from './Pages/listing';

export const ExportTagDetailsRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={ExportTagDetails} />
    </Fragment>
)